import React from 'react';

const SUGGESTED_TAGS = ['nature', 'landscape', 'portrait', 'travel', 'family', 'vacation', 'sunset', 'architecture'];

const TagSearchSection = ({ tags, setTags, onSearch, loading }) => {
  const handleSuggestionToggle = (tag) => {
    setTags(prev => {
      const currentTags = prev.split(',').map(t => t.trim()).filter(Boolean);
      if (currentTags.includes(tag)) {
        return currentTags.filter(t => t !== tag).join(', ');
      }

      return [...currentTags, tag].join(', ');
    });
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-3">Search by Tags</label>

      <div className="mb-3">
        <p className="text-xs text-gray-600 mb-2">Popular suggestions:</p>
        <div className="flex flex-wrap gap-2">
          {SUGGESTED_TAGS.map(tag => {
            const isActive = tags.split(',').map(t => t.trim()).includes(tag);

            return (
              <button
                key={tag}
                onClick={() => handleSuggestionToggle(tag)}
                className={`px-3 py-1 text-sm rounded-full border transition-colors duration-200 ${
                  isActive
                    ? 'bg-blue-100 text-blue-800 border-blue-300'
                    : 'bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100'
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>
      </div>

      <div className="flex space-x-2">
        <input
          type="text"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              onSearch();
            }
          }}
          className="flex-1 border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Add custom tags or use suggestions above"
        />
        <button
          onClick={onSearch}
          disabled={!tags.trim() || loading}
          className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          Search Tags
        </button>
      </div>
    </div>
  );
};

export default TagSearchSection;
